import {getWorkflowLabel} from "../../../../atoms/start-workflow/workflowMapping";
import {getUnionWorkflowTypes} from "../../../../utils/facilityWorkflowTypes";
import {SimpleFacilityModel} from "../../../../utils/types/facility";
import {WorkflowFilter} from "./types";

export {getUnionWorkflowTypes};

export const ALL_WORKFLOW_FILTER: WorkflowFilter = {id: null, label: "All"};

/** Show filter when the union across currently selected facilities has >1 type. */
export const shouldShowWorkflowFilter = (
  activeFacilitiesIds: ReadonlyArray<string> | null | undefined,
  facilitiesById: Record<string, SimpleFacilityModel | undefined>,
): boolean => {
  if (!activeFacilitiesIds?.length) {
    return false;
  }

  return getUnionWorkflowTypes(activeFacilitiesIds, facilitiesById).length > 1;
};

/** Dropdown display value: falls back to All when selection is outside current options. */
export const getDisplayWorkflowFilter = (
  selected: WorkflowFilter,
  options: ReadonlyArray<WorkflowFilter>,
): WorkflowFilter => {
  if (!selected.id) {
    return ALL_WORKFLOW_FILTER;
  }

  return (
    options.find(option => option.id === selected.id) ?? ALL_WORKFLOW_FILTER
  );
};

export const buildWorkflowFilterOptions = (
  workflowTypes: ReadonlyArray<string>,
): ReadonlyArray<WorkflowFilter> => [
  ALL_WORKFLOW_FILTER,
  ...workflowTypes.map(workflowType => ({
    id: workflowType,
    label: getWorkflowLabel(workflowType),
  })),
];

/** API workflow type: selected id only when it exists in the current scoped union. */
export const getEffectiveWorkflowType = (
  selectedId: string | null,
  unionTypes: ReadonlyArray<string>,
): string | null => {
  if (!selectedId) {
    return null;
  }

  return unionTypes.includes(selectedId) ? selectedId : null;
};
